import React, { useState, useRef, useMemo,useEffect } from 'react';
import PropTypes from 'prop-types';
// import './CustomTable.scss';
// import Modal from '../CustomModal/CustomModal';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
// import ROUTES_NAVIGATION from '../../../routes/routes';
// import axiosInstance from '../../services/api/API';
// import { toastError,toastSuccess } from './../../customComponents/customToast/Toast';
import Modal from '../../../customComponents/CustomModal/CustomModal';
import axiosInstance from '../../../services/api/API';
import { logDOM } from '@testing-library/react';

const CustomLogisticsTable = ({isOpenStatus,isADDcomplainTable, totalRecords,leadPriority, headers, data, keyMapping, itemsPerPage,currentPage, totalPages, onPageChange, isAllocation, onEdit=()=>{}, onDelete=()=>{} , handleViewButton=()=>{},handleDelete=()=>{}, handleAddLogistics=()=>{} , handleEditButton=()=>{},onPriviledges,onAdd,handleClicableRow=()=>{},onAddSerial=()=>{},onAddStockInSerial=()=>{},
actionToBeTaken=()=>{},pdfDownLoad=()=>{}, handleAllot=()=>{}}) => {
 console.log("currentPage",currentPage);
 
  //const [currentPage, setCurrentPage] = useState(0);
  const [checkboxState, setCheckboxState] = useState(data?.map(() => false));
  const [showModal, setShowModal] = useState(false);
  const [selectedAssignee, setSelectedAssignee] = useState('');
  const [assigneeList, setAssigneeList] = useState([
    // { name: 'Assignee 1', assignedLeads: 5 },
    // { name: 'Assignee 2', assignedLeads: 10 },
    // { name: 'Assignee 3', assignedLeads: 3 },
    
  ]); 
  const navigate=useNavigate()
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredAssigneeList, setFilteredAssigneeList] = useState(assigneeList);
  const assignButtonRef = useRef(null);
  const [modalPosition, setModalPosition] = useState({});
  const authToken = localStorage.getItem("authToken");
   const businessPartnerId=localStorage.getItem("business_partner_id");
     useEffect(() => {
      fetchAssigneeList();
  
  }, []);
         
  const fetchAssigneeList = async () => {
    
    try {
      const endpoint =  '/user/ddlleadexecutive';
      const response = await axiosInstance.post(
        endpoint,
        { business_partner_id: businessPartnerId ==="0"?null:businessPartnerId},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const assignees = response.data.data.data.map(assignee => ({
        name: assignee.NAME,
        id: assignee.ID,
        assignedLeads: assignee.assignedcount,
      }));
      setAssigneeList(assignees);
      setFilteredAssigneeList(assignees);
      console.log("filteredAssigneeList",filteredAssigneeList);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to fetch assignees. Please try again.";
     // toastError(errorMessage);
      console.error("Error fetching assignees:", error);
    }
  };
  const handlePreviousPage = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageClick = (pageIndex) => {
    onPageChange(pageIndex);
  };
  const visiblePages = 5; // Number of visible page buttons
  const startPage = Math.max(0, currentPage - Math.floor(visiblePages / 2));

  const endPage = Math.min(totalPages - 1, startPage + visiblePages - 1);
console.log("startPage",startPage);

  const handleCheckboxChange = (index) => {
    const updatedCheckboxState = [...checkboxState];
    updatedCheckboxState[index] = !updatedCheckboxState[index];
    setCheckboxState(updatedCheckboxState);
  };

  const handleAssignClick = () => {
    if (checkboxState.some(checked => checked)) {
      const rect = assignButtonRef.current.getBoundingClientRect();
      setModalPosition({
        top: rect.top + window.scrollY - 100, // Adjust the offset as needed
        left: rect.left + window.scrollX,
      });
      setShowModal(true);
    } else {
      //alert("Please select at least one row to assign.");
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleAssigneeChange = (event) => {
    setSelectedAssignee(event.target.value);
  };

  const getStartIndex = () => {
    return currentPage * itemsPerPage + 1;
  };

  const getEndIndex = () => {
    return Math.min((currentPage + 1) * itemsPerPage, totalRecords);
  };

  const handleAssign = async() => {
    const selectedRows = data.filter((_, index) => checkboxState[index]);
    const leadIds = selectedRows.map(row => row.lead_id).join(","); // Join the lead IDs into a comma-separated string
    console.log("selectedRows", selectedRows);
    console.log(`Assigning rows: ${leadIds} to ${selectedAssignee}`);
  
    try {
      await axiosInstance.post(
        "/presale/assignlead",
        {
          assigntype: "leadexecutive",
          lead_executive_id: 48, // Replace with your actual dynamic value
          lead_id: leadIds
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          }
        }
      );
     
      window.location.reload()
      // toastSuccess("Lead Assigned successfully!");
      // navigate(ROUTES_NAVIGATION.LEADALLOCATIONLIST);
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to assign lead. Please try again.";
      // toastError(errorMessage);
      console.error("Error submitting form:", error);
    }
    setShowModal(false);
  };
  
  const handleSearchChange = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    const filteredList = assigneeList.filter(assignee =>
      assignee.name.toLowerCase().includes(value)
    );
    setFilteredAssigneeList(filteredList);
  };

  const currentPageData = useMemo(() => {
    const offset = currentPage * itemsPerPage;
   
    return data?.slice(offset, offset + itemsPerPage);
  }, [currentPage, itemsPerPage, data]);
  

  return (
    <>
      <div className="logisticstable-container">
        <table className="custom-table">
          <thead >
            <tr >
              {headers?.map((header, index) => (
                <th   key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.map((row, rowIndex) => (
              <tr key={row.id} onClick={()=>handleClicableRow(row)}>
                {headers?.map((header, colIndex) => {
                  const key = keyMapping[header];
                  if (header === "Action") {
                    console.log("stockinrow",row);
                    return (
                      <td key={colIndex} data-tip={row[key]} data-for={`cell-tooltip-${row.id}-${colIndex}`}>
                        {key.map((action, actionIndex) => {
                          // Check if the action should be skipped
                          console.log("action",action);
                          
                          if (action.type === 'addserial' && row.defective_qty===0 && row.missing_qty===0 && row.pendingqty===0 ) {
                            console.log("rowData",row);
                            return null;
                          }
                    
                          // Determine the appropriate icon to display
                          const actionIcon = 
                            row.invoice_no !== null && action.type === 'print' ? action.icon :
                            action.type === 'delete' || 
                            action.type === 'addserial' || 
                            action.type === 'addstockinserial' || 
                            action.type === 'allot' || 
                             action.type === 'edit' || 
                            action.type === 'view' || 
                            (action.type === 'add' && row.allownewlead) || 
                            action.type === 'priviledge' ? action.icon : null;
                    
                          return (
                            <img
                              key={actionIndex}
                              src={actionIcon}
                              style={{ gap: 5, marginLeft: 10 }}
                              data-tip={action.label}
                              data-for={`action-tooltip-${row.id}-${actionIndex}`}
                              onClick={() => {
                                switch (action.type) {
                                  case 'edit':
                                    onEdit(row);
                                    break;
                                  case 'view':
                                    handleViewButton(row);
                                    break;
                                  case 'add':
                                    onAdd(row);
                                    break;
                                  case 'allot':
                                    handleAllot(row);
                                    break;
                                  case 'delete':
                                    onDelete(row);
                                    break;
                                  case 'priviledge':
                                    onPriviledges(row);
                                    break;
                                  case 'addLogistics':
                                    handleAddLogistics(row);
                                    break;
                                  case 'actiontobetaken':
                                    actionToBeTaken(row);
                                    break;
                                  case 'addserial':
                                    onAddSerial(row);
                                    break;
                                  case 'addstockinserial':
                                    onAddStockInSerial(row);
                                    break;
                                  case 'print':
                                    pdfDownLoad(row);
                                    break;
                                  default:
                                    break;
                                }
                              }}
                              className="action-icon"
                            />
                          );
                        })}
                      </td>
                    );
                    

                    // return (
                    //   <td key={colIndex} data-tip={row[key]} data-for={`cell-tooltip-${row.id}-${colIndex}`}>
                    //   {key.map((action, actionIndex) => (
                     
                    //  if (action.type === 'edit' && row.po_recvinvoice_id === 0) {
                    //   return null; 
                    // }
                    //       <img
                    //         key={actionIndex}
                    //         src={(row.invoice_no !== null && action.type === 'print') ? action?.icon:action.type === 'delete'?action?.icon:action.type === 'addserial'? action?.icon:action.type === 'addstockinserial'? action?.icon:action.type === 'allot'? action?.icon:action.type === 'addserial'? action?.icon:action.type === 'edit'?action.icon :action.type === 'view' ?  action.icon :(action.type === 'add' && row.allownewlead) ?  action.icon:action.type ==='priviledge' ? action.icon:null }
                    //         // height={20}
                    //         // width={28}
                    //         // alt={action.label}
                    //         style={{gap:5,marginLeft:10}}
                    //         data-tip={action.label}
                    //         data-for={`action-tooltip-${row.id}-${actionIndex}`}
                    //         onClick={() => {
                    //           if (action.type === 'edit') {
                    //             onEdit(row);
                    //             // handleEditButton()
                    //           } else if (action.type === 'view') {
                    //             handleViewButton(row)
                    //             // handleView(row.id);
                    //           } else if (action.type === 'add') {
                    //              onAdd(row)
                    //           }
                    //           else if (action.type === 'allot') {
                    //             handleAllot(row)
                    //          }
                    //           else if (action.type === 'delete') {
                    //             onDelete(row)
                    //          }
                    //           else if (action.type === 'priviledge') {
                    //             //navigate(ROUTES_NAVIGATION.USERPRIVILEGES)  
                    //             onPriviledges(row)
                    //           }else if ( action.type === "delete" ){
                    //              handleDelete("clicked")
                    //           } else if( action.type === "addLogistics" ){
                    //             handleAddLogistics(row)
                    //           }
                    //           else if (action.type === 'actiontobetaken') {
                    //             //navigate(ROUTES_NAVIGATION.USERPRIVILEGES)  
                    //             actionToBeTaken(row)
                    //           }
                    //           else if (action.type === 'addserial') {
                    //             //navigate(ROUTES_NAVIGATION.USERPRIVILEGES)  
                    //             onAddSerial(row)
                    //           }else if (action.type === 'addstockinserial'){
                    //             onAddStockInSerial(row)
                    //           }
                    //           else if(action.type === 'print'){
                    //           pdfDownLoad(row)
                    //           }
                    //         }}
                    //         className="action-icon" 
                            
                    //       />
                     
                    //   ))}
                    // </td>
                    // );
                  }

                  if (header === "Allocate") {
                    //alert("hello")
                    const checkboxIndex = currentPage * itemsPerPage + rowIndex;
                    console.log("checkboxIndex",currentPage);
                    return (
                      <td key={colIndex}>
                        <input
                          type="checkbox"
                          checked={checkboxState[checkboxIndex]}
                          onChange={() => handleCheckboxChange(checkboxIndex)}
                        />
                      </td>
                    );
                  }

                  // if (editRow && header === "Quantity") {
                   //   return (
                  //     <td key={colIndex}>
                  //       <input
                  //         style={{
                  //           width: "56px",
                  //           borderRadius: "4px",
                  //           border: "1.5px solid green",
                  //           padding: "5px",
                  //           fontSize: "12px",
                  //           textAlign: "left",
                  //           fontWeight: "600",
                  //         }}
                  //         type="number" // Changed input type to number
                  //       />
                  //     </td>
                  //   );
                  // } else {
                  //   // Render other cells or a default cell here
                  //   return (
                  //     <td key={colIndex}>
                        
                  //     </td>
                  //   );
                  // }
                  // if (header === "Quantity") {
                  //   return (
                  //     <td key={colIndex}>
                  //       <input
                  //       style={{width:"56px", borderRadius:"4px",border:"1.5px solid green", padding:"5px", fontSize:"12px", textAlign:"left", fontWeight:"600"}}
                  //         type="number"  // Changed input type to number

                  //       />
                  //     </td>
                  //   );
                  // }

                  if (header === "Lead Priority") {
                    return (
                      <td  
                        key={colIndex}
                        className=''
                      >
                       <span 
                    className={
                      row[key] === "Warm Leads" ? "warmLeads" : 
                      row[key] === "Hot Leads" ? "hotLeads" :
                      row[key] === "Cold Leads" ? "coldLeads" : ''
                    }
                  >
                    {row[key]}
                  </span>
                                  </td>
                                );
                              }

                  if (header === "Status") {
                    return (
                      <td
                        key={colIndex}
                        className='statusheader'
                      >
                        {
                          isOpenStatus ? 
                          <span className={row[key] === "Active" ? 'openStatus' :'openStatus'}>{row[key]}</span> 
                          :
                          <span className={row[key] === "Active" ?  'active-status' :row[key] === "Done" ? 'active-status':'inactive-status'}>{row[key]}</span> 
                        }

                      </td>
                    );
                  }
                  return (
                    <td key={colIndex}>
                      {row[key]}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!isADDcomplainTable && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 20px",
            width: "100%",
          }}
        >
          <div className="totalDataCounts">
            {totalRecords > 0
              ? `Showing ${getStartIndex()} to ${getEndIndex()} of Total ${totalRecords} Records`
              : "No records found"}
          </div>
          <div className="pagination">
            <FaChevronLeft
              onClick={handlePreviousPage}
              className={
                currentPage === 0
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
            <div className="pagination-btns">
              {startPage > 0 && (
                <span
                  onClick={() => handlePageClick(0)}
                  className="pagination-btn"
                >
                  1
                </span>
              )}
              {startPage > 1 && <span className="pagination-btn">...</span>}
              {Array.from({ length: endPage - startPage + 1 }, (_, index) => (
                <span
                  key={startPage + index}
                  onClick={() => handlePageClick(startPage + index)}
                  className={
                    currentPage === startPage + index
                      ? "pagination-btn pagination-active"
                      : "pagination-btn"
                  }
                >
                  {startPage + index + 1}
                </span>
              ))}
              {endPage < totalPages - 2 && (
                <span className="pagination-btn">...</span>
              )}
              {endPage < totalPages - 1 && (
                <span
                  onClick={() => handlePageClick(totalPages - 1)}
                  className="pagination-btn"
                >
                  {totalPages}
                </span>
              )}
            </div>
            <FaChevronRight
              onClick={handleNextPage}
              className={
                currentPage === totalPages - 1
                  ? "pagination-icon disabled"
                  : "pagination-icon"
              }
            />
          </div>
        </div>
      )}
      {isAllocation && (
        <div style={{ textAlign: 'right' }}>
          <button ref={assignButtonRef} onClick={handleAssignClick} className="assign-button">
            Assign To
          </button>
        </div>
      )}

      {showModal && isAllocation && (
        <Modal show={showModal} handleClose={handleModalClose} position={modalPosition}>
          <span className='modalheading'>Select Lead Executive</span>
          <input
            type="text"
            placeholder="Search Assignee"
            className="leadmodalsearch mt-2 mb-2"
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <div className="assignee-list">
            {filteredAssigneeList.map((assignee, index) => (
              <div key={index} className="assignee-item mt-2">
                <label htmlFor={`assignee-${index}`}>{assignee.name}</label>
                <div className='countcontainer'>
                  <label htmlFor={`assignee-${index}`} className='counttotal'>{assignee.assignedLeads} leads Assigned</label>
                  <input
                    type="radio"
                      style={{height:20,width:20}}
                    id={`assignee-${index}`}
                    name="assignee"
                    value={assignee.name}
                    onChange={handleAssigneeChange}
                    checked={selectedAssignee === assignee.name}
                  />
                </div>
              </div>
            ))}
          </div>
          <div className='modalbuttons mt-2 mb-2'>
            <button onClick={handleModalClose} className='leadbtn'>Cancel</button>
            <button onClick={handleAssign} className='leadbtn'>Assign Lead</button>
          </div>
        </Modal>
      )}
      
    </>
  );
};

CustomLogisticsTable.propTypes = {
  headers: PropTypes?.arrayOf(PropTypes.string).isRequired,
  data: PropTypes?.arrayOf(PropTypes.object).isRequired,
  keyMapping: PropTypes.object.isRequired,
  itemsPerPage: PropTypes.number,
  isAllocation: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};

CustomLogisticsTable.defaultProps = {
  itemsPerPage: 10,
  isAllocation: false,
};

export default CustomLogisticsTable;